/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './security/auth.guard';
import {PersonalComponent} from './personal/personal.component';
import {ManagerComponent} from './manager/manager.component';
import {HrComponent} from './hr/hr.component';
import {WorkAbroadComponent} from './work-abroad/work-abroad.component';

const routes: Routes = [
    {
        path: '', redirectTo: '/', pathMatch: 'full'

    },
    {
        path: 'not-authorized',
        loadChildren: () =>
            import('./shared/shared.module').then((module) => module.SharedModule),
    },
    {
        path: 'personal',
        component: PersonalComponent,
    },
    {
        path: 'work-abroad',
        component: WorkAbroadComponent,
    },
    {
        path: 'team',
        component: ManagerComponent,
        canActivate: [AuthGuard],
        data: {requiredRole: 'abt_manager', allowedRoles: ['Managers_IRL_Autopop']}
    },
    {
        path: 'company',
        component: HrComponent,
        canActivate: [AuthGuard],
        data: {requiredRole: 'abt_hr'}
    },
    {
        path: '**',
        redirectTo: '/',
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
